import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import HeroSection from '../components/sections/HeroSection'
import TestimonialsSection from '../components/sections/TestimonialsSection'
import PortfolioSection from '../components/sections/PortfolioSection'
import ProcessSection from '../components/sections/ProcessSection'
import FAQSection from '../components/sections/FAQSection'
import ErrorBoundary from '../components/ErrorBoundary'

// Lazy load other heavy components only
const ServicesSection = lazy(() => import('../components/sections/ServicesSection'))

export const Route = createFileRoute('/')({
  component: Index,
})

function Index() {
  return (
    <>
      <HeroSection />
      <TestimonialsSection />
      <ErrorBoundary fallback={<div className="w-full h-64 bg-slate-900/50 rounded-xl flex items-center justify-center text-slate-400">Failed to load services</div>}>
        <Suspense fallback={<div className="w-full h-64 bg-slate-900/50 animate-pulse rounded-xl" />}>
          <ServicesSection />
        </Suspense>
      </ErrorBoundary>
      <PortfolioSection />
      <ProcessSection />
      <FAQSection />
    </>
  );
}
